<template>
  <!-- Sidebar Area Start Here -->

  <v-navigation-drawer
    v-model="drawer"
    class="main-sidebar not-printable"
    :class="currentAppLocale == 'ar' ? 'text-right' : ''"
    :expand-on-hover="expandOnHover"
    :mini-variant="miniVariant"
    :right="currentAppLocale == 'ar'"
    :src="bg"
    absolute
    dark
    stateless
    value="true"
  >
    <v-list dense nav class="py-0">
      <v-list-item two-line :class="miniVariant && 'px-0'">
        <v-list-item-avatar>
          <img :src="localimage" />
        </v-list-item-avatar>

        <v-list-item-content>
          <v-list-item-title>
            {{ "iSkola Canteen" }}
          </v-list-item-title>
        </v-list-item-content>
      </v-list-item>

      <v-divider></v-divider>
      <v-list-item v-if="largeScreen">
        <v-btn icon @click.stop="setSideBarMin" v-if="miniVariant">
          <v-icon v-if="currentAppLocale != 'ar'">mdi-chevron-right</v-icon>
          <v-icon v-else>mdi-chevron-left</v-icon>
        </v-btn>
        <v-btn icon @click.stop="setSideBarMin" v-if="!miniVariant">
          <v-icon v-if="currentAppLocale != 'ar'">mdi-chevron-left</v-icon>
          <v-icon v-else>mdi-chevron-right</v-icon>
        </v-btn>
      </v-list-item>

      <v-list-item v-if="!largeScreen">
        <v-btn icon @click="closeSidebar" style="color: white !important">
          <v-icon style="color: white !important">{{ $t("close") }}</v-icon>
        </v-btn>
      </v-list-item>

      <v-list-item link to="/" class="single">
        <v-list-item-icon :class="currentAppLocale == 'ar' ? 'mr-3' : ''">
          <i class="fas fa-chart-line"></i>
        </v-list-item-icon>

        <v-list-item-content>
          <v-list-item-title>{{ $t("Home") }}</v-list-item-title>
        </v-list-item-content>
      </v-list-item>

      <!-- masterDatashowMenu -->
      <v-list-group no-action="no-action" ref="schoolSetup" v-if="isSuperAdmin">
        <v-list-item slot="activator">
          <div @click="masterDatashowMenu">
            <v-list-item-icon>
              <!-- <i class="mdi mdi-cog"></i> -->
              <svg
                xmlns="http://www.w3.org/2000/svg"
                width="18"
                height="18"
                viewBox="0 0 18 18"
                fill="none"
              >
                <path
                  d="M13.9503 8.78C13.9803 8.53 14.0003 8.27 14.0003 8C14.0003 7.73 13.9803 7.47 13.9403 7.22L15.6303 5.9C15.7803 5.78 15.8203 5.56 15.7303 5.39L14.1303 2.62C14.0303 2.44 13.8203 2.38 13.6403 2.44L11.6503 3.24C11.2303 2.92 10.7903 2.66 10.3003 2.46L10.0003 0.34C9.97025 0.14 9.80025 0 9.60025 0H6.40025C6.20025 0 6.04025 0.14 6.01025 0.34L5.71025 2.46C5.22025 2.66 4.77025 2.93 4.36025 3.24L2.37025 2.44C2.19025 2.37 1.98025 2.44 1.88025 2.62L0.280252 5.39C0.180252 5.57 0.220252 5.78 0.380252 5.9L2.07025 7.22C2.03025 7.47 2.00025 7.74 2.00025 8C2.00025 8.26 2.02025 8.53 2.06025 8.78L0.370252 10.1C0.220252 10.22 0.180252 10.44 0.270252 10.61L1.87025 13.38C1.97025 13.56 2.18025 13.62 2.36025 13.56L4.35025 12.76C4.77025 13.08 5.21025 13.34 5.70025 13.54L6.00025 15.66C6.04025 15.86 6.20025 16 6.40025 16H9.60025C9.80025 16 9.97025 15.86 9.99025 15.66L10.2903 13.54C10.7803 13.34 11.2303 13.07 11.6403 12.76L13.6303 13.56C13.8103 13.63 14.0203 13.56 14.1203 13.38L15.7203 10.61C15.8203 10.43 15.7803 10.22 15.6203 10.1L13.9503 8.78ZM8.00025 11C6.35025 11 5.00025 9.65 5.00025 8C5.00025 6.35 6.35025 5 8.00025 5C9.65025 5 11.0003 6.35 11.0003 8C11.0003 9.65 9.65025 11 8.00025 11Z"
                  fill="white"
                />
              </svg>
            </v-list-item-icon>
          </div>

          <v-list-item-title>{{ $t("Settings") }}</v-list-item-title>
          <v-menu
            v-if="miniVariant"
            v-model="masterDataMenu.value"
            :close-on-click="masterDataMenu.closeOnClick"
            :close-on-content-click="masterDataMenu.closeOnContentClick"
            :offset-x="masterDataMenu.offsetX"
            :offset-y="masterDataMenu.offsetY"
          >
            <template v-slot:activator>
              <v-list-item-icon>
                <i class="fas fa-school"></i>
              </v-list-item-icon>
            </template>
          </v-menu>
        </v-list-item>
        <div>
          <v-list-item
            link
            v-for="(item, index) in schoolSetup"
            :key="index"
            :to="item.to"
          >
            <v-list-item v-if="item.enabled">
              <v-list-item-content>
                <v-list-item-title>{{ item.title }}</v-list-item-title>
              </v-list-item-content>
            </v-list-item>
          </v-list-item>
        </div>
      </v-list-group>
      <!-- ----------------------Canteen-Staff---------------------- -->
      <v-list-group no-action="no-action" ref="schoolSetup" v-if="isSuperAdmin">
        <v-list-item slot="activator">
          <div @click="masterDatashowMenu">
            <v-list-item-icon>
              <!-- <i class="fas fa-school"></i> -->
              <i class="fas fa-user"></i>
            </v-list-item-icon>
          </div>

          <v-list-item-title>{{ $t("Staff") }}</v-list-item-title>
          <v-menu
            v-if="miniVariant"
            v-model="masterDataMenu.value"
            :close-on-click="masterDataMenu.closeOnClick"
            :close-on-content-click="masterDataMenu.closeOnContentClick"
            :offset-x="masterDataMenu.offsetX"
            :offset-y="masterDataMenu.offsetY"
          >
            <template v-slot:activator>
              <v-list-item-icon>
                <i class="fas fa-school"></i>
              </v-list-item-icon>
            </template>
          </v-menu>
        </v-list-item>

        <div>
          <v-list-item
            link
            v-for="(item, index) in canteenStaff"
            :key="index"
            :to="item.to"
          >
            <v-list-item v-if="item.enabled">
              <v-list-item-content>
                <v-list-item-title>{{ item.title }}</v-list-item-title>
              </v-list-item-content>
            </v-list-item>
          </v-list-item>
        </div>
        <!--  -->
      </v-list-group>
      <!-- -------------end--------------------- -->
      <!-- ----------------------Canteen-Staff---------------------- -->

      <!-- -------------end--------------------- -->
      <!-- ----------------------Product data---------------------- -->
      <v-list-group
        no-action="no-action"
        v-if="isWarehouseStaff || isSuperAdmin"
        ref="schoolSetup"
      >
        <v-list-item slot="activator">
          <div @click="masterDatashowMenu">
            <v-list-item-icon>
              <!-- <i class="fas fa-school"></i> -->
              <i class="fas fa-shopping-basket"></i>
            </v-list-item-icon>
          </div>

          <v-list-item-title>{{ $t("Products") }}</v-list-item-title>

          <v-menu
            v-if="miniVariant"
            v-model="masterDataMenu.value"
            :close-on-click="masterDataMenu.closeOnClick"
            :close-on-content-click="masterDataMenu.closeOnContentClick"
            :offset-x="masterDataMenu.offsetX"
            :offset-y="masterDataMenu.offsetY"
          >
            <template v-slot:activator>
              <v-list-item-icon>
                <i class="fas fa-school"></i>
              </v-list-item-icon>
            </template>
          </v-menu>
        </v-list-item>

        <div>
          <!-- <div v-if="item.enabled"> -->
          <v-list-item
            link
            v-for="(item, index) in productsItems"
            :key="index"
            :to="item.to"
          >
            <v-list-item v-if="item.enabled">
              <v-list-item-content>
                <v-list-item-title>{{ item.title }}</v-list-item-title>
              </v-list-item-content>
            </v-list-item>
          </v-list-item>
        </div>
        <!--  -->
      </v-list-group>
      <!-- -------------end--------------------- -->

      <!-- ----------------------Order Cart---------------------- -->
      <v-list-item link to="/orders" class="single" v-if="isCanteenStaff">
        <v-list-item-icon>
          <svg
            width="20"
            height="21"
            viewBox="0 0 20 21"
            fill="none"
            xmlns="http://www.w3.org/2000/svg"
          >
            <path
              d="M6 16.5781C4.9 16.5781 4.01 17.4781 4.01 18.5781C4.01 19.6781 4.9 20.5781 6 20.5781C7.1 20.5781 8 19.6781 8 18.5781C8 17.4781 7.1 16.5781 6 16.5781ZM0 0.578125V2.57812H2L5.6 10.1681L4.25 12.6181C4.09 12.8981 4 13.2281 4 13.5781C4 14.6781 4.9 15.5781 6 15.5781H18V13.5781H6.42C6.28 13.5781 6.17 13.4681 6.17 13.3281L6.2 13.2081L7.1 11.5781H14.55C15.3 11.5781 15.96 11.1681 16.3 10.5481L19.88 4.05813C19.9625 3.90551 20.004 3.73411 20.0005 3.56065C19.9969 3.3872 19.9485 3.21763 19.8598 3.06851C19.7711 2.91939 19.6453 2.79582 19.4946 2.70987C19.3439 2.62392 19.1735 2.57853 19 2.57812H4.21L3.27 0.578125H0ZM16 16.5781C14.9 16.5781 14.01 17.4781 14.01 18.5781C14.01 19.6781 14.9 20.5781 16 20.5781C17.1 20.5781 18 19.6781 18 18.5781C18 17.4781 17.1 16.5781 16 16.5781Z"
              fill="white"
            />
          </svg>
        </v-list-item-icon>

        <v-list-item-content>
          <v-list-item-title>{{ $t("Orders") }}</v-list-item-title>
        </v-list-item-content>
      </v-list-item>
      <!-- -------------end--------------------- -->
      <!-- ----------------------Wallet data---------------------- -->
      <v-list-item link to="/points" class="single" v-if="isParent">
        <v-list-item-icon :class="currentAppLocale == 'ar' ? 'mr-3' : ''">
          <svg
            xmlns="http://www.w3.org/2000/svg"
            fill="none"
            width="20"
            height="21"
            viewBox="0 0 24 24"
          >
            <title>wallet-outline</title>
            <path
              d="M5,3C3.89,3 3,3.9 3,5V19A2,2 0 0,0 5,21H19A2,2 0 0,0 21,19V16.72C21.59,16.37 22,15.74 22,15V9C22,8.26 21.59,7.63 21,7.28V5A2,2 0 0,0 19,3H5M5,5H19V7H13A2,2 0 0,0 11,9V15A2,2 0 0,0 13,17H19V19H5V5M13,9H20V15H13V9M16,10.5A1.5,1.5 0 0,0 14.5,12A1.5,1.5 0 0,0 16,13.5A1.5,1.5 0 0,0 17.5,12A1.5,1.5 0 0,0 16,10.5Z"
              fill="white"
            />
          </svg>
        </v-list-item-icon>

        <v-list-item-content>
          <v-list-item-title>{{ $t("Points") }}</v-list-item-title>
        </v-list-item-content>
      </v-list-item>
      <!-- -------------end--------------------- -->
      <!-- ----------------------OrdersHistory data---------------------- -->
      <v-list-item
        link
        :to="'/OrdersHistory/' + auth_id"
        class="single"
        v-if="isParent || isStudent"
      >
        <v-list-item-icon :class="currentAppLocale == 'ar' ? 'mr-3' : ''">
          <svg
            xmlns="http://www.w3.org/2000/svg"
            fill="none"
            width="20"
            height="21"
            viewBox="0 0 29 29"
          >
            <title>student-wallet-outline</title>
            <path
              xmlns="http://www.w3.org/2000/svg"
              d="M24.3158 3.09165L3.47368 3.09166L3.47368 24.3159L15.6316 24.3159L15.6316 27.7895L3.47368 27.7896C1.56316 27.7896 -1.36656e-07 26.2264 -3.03679e-07 24.3159L-2.12575e-06 3.47376C-2.29278e-06 1.56323 1.56316 7.61573e-05 3.47368 7.59903e-05L24.3158 7.41682e-05C26.2263 7.40012e-05 27.7895 1.56323 27.7895 3.47376L27.7895 15.6317L24.3158 15.6317L24.3158 3.09165Z"
              fill="white"
            />
            <path
              xmlns="http://www.w3.org/2000/svg"
              d="M6.94739 15.6316L6.94739 12.1579L20.8421 12.1579L20.8421 15.6316L15.6316 15.6316L6.94739 15.6316Z"
              fill="white"
            />
            <path
              xmlns="http://www.w3.org/2000/svg"
              d="M20.8421 10.4211L6.94739 10.4211L6.94739 6.94746L20.8421 6.94746L20.8421 10.4211Z"
              fill="white"
            />
            <path
              xmlns="http://www.w3.org/2000/svg"
              d="M23.2736 30.221C22.5094 30.221 21.8911 30.8463 21.8911 31.6105C21.8911 32.3747 22.5094 33 23.2736 33C24.0378 33 24.6631 32.3747 24.6631 31.6105C24.6631 30.8463 24.0378 30.221 23.2736 30.221ZM19.1053 19.1052V20.4947H20.4948L22.9957 25.7678L22.0579 27.4699C21.9467 27.6644 21.8842 27.8936 21.8842 28.1368C21.8842 28.901 22.5094 29.5263 23.2736 29.5263H31.6102V28.1368H23.5654C23.4681 28.1368 23.3917 28.0604 23.3917 27.9631L23.4126 27.8798L24.0378 26.7473H29.2134C29.7345 26.7473 30.193 26.4625 30.4292 26.0318L32.9162 21.5229C32.9736 21.4169 33.0024 21.2978 32.9999 21.1773C32.9975 21.0568 32.9638 20.939 32.9022 20.8354C32.8406 20.7318 32.7532 20.6459 32.6485 20.5862C32.5438 20.5265 32.4254 20.495 32.3049 20.4947H22.0301L21.3771 19.1052H19.1053ZM30.2208 30.221C29.4566 30.221 28.8383 30.8463 28.8383 31.6105C28.8383 32.3747 29.4566 33 30.2208 33C30.9849 33 31.6102 32.3747 31.6102 31.6105C31.6102 30.8463 30.9849 30.221 30.2208 30.221Z"
              fill="white"
            />
            <rect
              xmlns="http://www.w3.org/2000/svg"
              x="6.94739"
              y="17.3684"
              width="8.68421"
              height="3.47368"
              fill="white"
            />
          </svg>
        </v-list-item-icon>

        <v-list-item-content>
          <v-list-item-title>{{ $t("Order List") }}</v-list-item-title>
        </v-list-item-content>
      </v-list-item>
      <!-- -------------end--------------------- -->
      <!-- ----------------------  Transfers data  ---------------------- -->
      <v-list-item link :to="'/Transfers/'" class="single" v-if="isParent">
        <v-list-item-icon :class="currentAppLocale == 'ar' ? 'mr-3' : ''">
          <svg
            xmlns="http://www.w3.org/2000/svg"
            width="20"
            height="21"
            viewBox="0 0 29 29"
            fill="none"
          >
            <g clip-path="url(#clip0_429_5230)">
              <path
                d="M-1.57351e-05 0.0144402L28.0041 0L28.0185 28.0041L0.0144244 28.0185L-1.57351e-05 0.0144402Z"
                fill="white"
              />
              <path
                d="M2.33847 9.34797L7.00342 4.67821L7.00522 8.17873L24.5078 8.1697L24.509 10.5034L7.00642 10.5124L7.00823 14.0129L2.33847 9.34797Z"
                fill="#7297FF"
              />
              <path
                d="M25.68 18.6705L21.0151 23.3403L21.0133 19.8398L3.51071 19.8488L3.5095 17.5151L21.0121 17.5061L21.0103 14.0056L25.68 18.6705Z"
                fill="#7297FF"
              />
            </g>
            <defs>
              <clipPath id="clip0_429_5230">
                <rect
                  width="28.0041"
                  height="28.0041"
                  rx="3"
                  transform="matrix(-1 0.000515645 0.000515645 1 28.0041 0)"
                  fill="white"
                />
              </clipPath>
            </defs>
          </svg>
        </v-list-item-icon>

        <v-list-item-content>
          <v-list-item-title>{{ $t("Transfers") }}</v-list-item-title>
        </v-list-item-content>
      </v-list-item>
      <!-- -------------end--------------------- -->

      <!-------------------------- Accountant Transfers -------------------------->
      <v-list-item link :to="'/Recharges/'" class="single" v-if="isAccountant">
        <v-list-item-icon :class="currentAppLocale == 'ar' ? 'mr-3' : ''">
          <svg
            xmlns="http://www.w3.org/2000/svg"
            width="20"
            height="20"
            viewBox="0 0 30 33"
            fill="none"
          >
            <g clip-path="url(#clip0_1078_6287)">
              <path
                fill-rule="evenodd"
                clip-rule="evenodd"
                d="M22.3316 16.3512H26.6038V15.5099C26.3595 14.5893 25.9709 13.9651 25.4665 13.585C24.9639 13.2063 24.3101 13.0439 23.5437 13.0497L5.59873 13.0536C5.16772 13.0536 4.81835 12.698 4.81835 12.2586C4.81835 11.82 5.16772 11.4644 5.59873 11.4644L8.09873 11.465C7.83228 11.0424 7.6076 10.5908 7.42848 10.1154C7.32911 9.8468 7.24304 9.57495 7.17215 9.29601H4.22342C3.49241 9.29601 2.82658 9.60136 2.34367 10.0929C1.86139 10.5838 1.56139 11.2614 1.56139 12.0061V28.701C1.56139 29.4444 1.86203 30.1221 2.34494 30.613C2.82595 31.1064 3.49241 31.4111 4.22342 31.4111H23.9411C24.6715 31.4111 25.3373 31.1051 25.8209 30.6142C26.3032 30.1221 26.6038 29.4437 26.6038 28.701V26.3194H22.3316C21.012 26.3194 19.8127 25.7699 18.9456 24.8867L18.8639 24.7965C18.0437 23.9179 17.538 22.7345 17.538 21.4403V21.2303C17.538 19.8936 18.0772 18.6748 18.9456 17.789L18.9538 17.7807C19.8241 16.8988 21.0196 16.3512 22.3316 16.3512ZM28.1652 16.3963C28.6152 16.4878 29.0184 16.7145 29.331 17.0328C29.743 17.4521 30 18.0332 30 18.6729V23.8985C30 24.5601 29.7323 25.165 29.2994 25.6063C28.9885 25.9264 28.5955 26.1512 28.1652 26.255V28.701C28.1652 29.8792 27.688 30.9537 26.9228 31.7326L26.9196 31.7358C26.1544 32.5146 25.0987 33.0003 23.9411 33.0003H4.22342C3.06646 33.0003 2.00949 32.5152 1.24241 31.7351C0.475949 30.9582 0 29.8837 0 28.701V12.0061C0 10.8227 0.475316 9.74759 1.23987 8.96876C2.00443 8.19058 3.06076 7.70679 4.22342 7.70679H6.95C6.94684 7.62176 6.94557 7.53608 6.94557 7.44976C6.94557 5.39479 7.76582 3.53114 9.09747 2.17319C11.9487 -0.720522 16.6095 -0.726964 19.4595 2.17319L19.5297 2.25113C20.8152 3.59749 21.607 5.43151 21.607 7.44976C21.607 7.53608 21.6051 7.62176 21.6025 7.70679H23.9411C25.1 7.70679 26.1557 8.19187 26.9215 8.97134C27.6886 9.74888 28.1652 10.8253 28.1652 12.0061V16.3963ZM20.4532 11.4663H23.5228C24.6247 11.456 25.5956 11.7111 26.3937 12.3134C26.4652 12.3675 26.5354 12.4242 26.6038 12.4835V12.0061C26.6038 11.264 26.3032 10.5857 25.8196 10.0935C25.3392 9.60071 24.6741 9.29601 23.9411 9.29601H21.3797C21.3101 9.57559 21.2241 9.84937 21.1241 10.1154C20.9456 10.5921 20.7203 11.0431 20.4532 11.4663ZM13.0816 4.16825C13.0791 3.85839 13.0506 3.63614 13.4291 3.64194L14.9772 3.65676C15.3715 3.65483 15.4766 3.78238 15.4722 4.15858V5.65053H16.9285C17.2329 5.6486 17.4506 5.61961 17.4449 6.00419L17.4304 7.57989C17.4323 7.98186 17.3076 8.0888 16.9373 8.08429H15.4722V9.57495C15.4766 9.9518 15.3715 10.0793 14.9772 10.0768L13.4291 10.0916C13.0506 10.0974 13.0791 9.87578 13.0816 9.56593V8.08429H11.6158C11.2456 8.0888 11.1203 7.98122 11.1228 7.57989L11.1082 6.00419C11.1019 5.61961 11.3203 5.6486 11.6247 5.65053H13.0816V4.16825ZM14.2766 1.25328C17.6386 1.25328 20.3639 4.02717 20.3639 7.44976C20.3639 9.04091 19.7741 10.4923 18.8051 11.5893H9.74684C8.77785 10.4923 8.18861 9.04091 8.18861 7.44976C8.18861 4.02717 10.9139 1.25328 14.2766 1.25328ZM22.7272 19.3428C23.2418 19.3428 23.7089 19.556 24.0468 19.9007C24.3873 20.2473 24.5968 20.7227 24.5968 21.2464C24.5968 21.7695 24.3873 22.2449 24.0494 22.5895C23.7089 22.9361 23.2418 23.1493 22.7272 23.1493C22.2133 23.1493 21.7468 22.9361 21.4076 22.5921L21.4038 22.5883C21.0658 22.243 20.8576 21.7682 20.8576 21.2464C20.8576 20.7233 21.0671 20.2479 21.4051 19.9033L21.4089 19.8994C21.7475 19.556 22.2139 19.3428 22.7272 19.3428Z"
                fill="white"
              />
            </g>
            <defs>
              <clipPath id="clip0_1078_6287">
                <rect width="30" height="33" fill="white" />
              </clipPath>
            </defs>
          </svg>
        </v-list-item-icon>

        <v-list-item-content>
          <v-list-item-title>{{ $t("Recharges") }}</v-list-item-title>
        </v-list-item-content>
      </v-list-item>
      <!------------------------ Academic Setup -------------------------->
      <!-------------------------- Accountant Transfers -------------------------->
      <v-list-item
        link
        :to="'/RefundRequests'"
        class="single"
        v-if="isAccountant"
      >
        <v-list-item-icon :class="currentAppLocale == 'ar' ? 'mr-3' : ''">
          <svg
            xmlns="http://www.w3.org/2000/svg"
            width="25"
            height="25"
            viewBox="0 0 30 33"
            fill="none"
          >
            <g clip-path="url(#clip0_1077_6259)">
              <path
                d="M0.109863 22.6886C0.153774 22.6098 0.201062 22.5319 0.240751 22.4515C0.516884 21.8917 0.961909 21.5639 1.58595 21.5521C2.61955 21.5335 3.654 21.5411 4.68844 21.5487C5.20355 21.5521 5.47377 21.7147 5.98635 22.2609C6.98702 21.8172 7.9708 21.3683 8.96724 20.9474C9.3236 20.7967 9.70613 20.7044 10.0819 20.6044C10.7558 20.4249 11.3976 20.5875 12.0292 20.8187C14.1707 21.6029 16.1763 22.6733 18.1869 23.7353C18.2984 23.7946 18.4073 23.8598 18.5213 23.9132C19.1631 24.2104 19.6419 24.6559 19.8344 25.3884C20.6358 25.1115 21.4203 24.843 22.2031 24.5712C23.7433 24.036 25.2828 23.499 26.8222 22.9613C27.279 22.8021 27.7468 22.7258 28.2206 22.847C28.94 23.0316 29.342 23.5261 29.4771 24.2426C29.6038 24.9159 29.2846 25.6374 28.6681 26.0075C27.7198 26.5766 26.7614 27.1287 25.7979 27.6724C23.056 29.2205 20.3174 30.7745 17.4353 32.0516C16.8484 32.3116 16.2303 32.5022 15.6274 32.7249C15.3318 32.7249 15.0363 32.7249 14.7407 32.7249C14.7112 32.7012 14.685 32.6639 14.652 32.6563C13.9444 32.4886 13.3178 32.1465 12.7216 31.7459C11.9692 31.2412 11.2312 30.7153 10.4822 30.2063C9.89951 29.81 9.27969 29.5576 8.55262 29.7287C8.34911 29.7761 8.13377 29.7718 7.92604 29.8057C7.34844 29.8997 6.77253 30.0005 6.20675 30.0979C6.124 31.1082 5.54218 31.7027 4.6496 31.7087C3.63795 31.7154 2.62546 31.7188 1.61382 31.7061C0.974574 31.6976 0.523641 31.3716 0.241596 30.8025C0.201908 30.722 0.155462 30.6441 0.111551 30.5654C0.109862 27.9392 0.109863 25.3139 0.109863 22.6886ZM6.19071 29.0529C6.83924 28.9512 7.46582 28.8733 8.08311 28.7505C9.17751 28.532 10.1731 28.7302 11.0826 29.3797C11.6061 29.7532 12.1238 30.1394 12.6701 30.4773C13.295 30.8635 13.9402 31.2209 14.5946 31.5554C14.9712 31.7476 15.3833 31.7645 15.7904 31.5969C16.3544 31.3657 16.9346 31.17 17.4868 30.9143C20.4711 29.533 23.3228 27.9011 26.177 26.2734C26.818 25.9084 27.4589 25.5442 28.0939 25.1691C28.4232 24.9751 28.5533 24.6364 28.452 24.3044C28.3489 23.9665 28.066 23.7794 27.6649 23.8149C27.4792 23.8319 27.2925 23.8835 27.1152 23.9445C24.7584 24.7584 22.4024 25.5739 20.0506 26.4004C19.9138 26.4487 19.7702 26.5817 19.706 26.7121C19.2019 27.7385 18.0053 28.2153 17.0089 27.6919C15.8908 27.105 14.8074 26.4496 13.7265 25.7958C13.5956 25.717 13.4791 25.4418 13.5163 25.2995C13.5593 25.1335 13.7569 24.9658 13.9275 24.8896C14.0331 24.843 14.2273 24.9413 14.359 25.0166C15.3563 25.5849 16.3452 26.1701 17.3433 26.7366C17.8533 27.0254 18.474 26.8459 18.7408 26.3581C19.0195 25.8491 18.8523 25.269 18.3304 24.9701C18.002 24.7821 17.6659 24.6042 17.3306 24.4281C15.4855 23.4584 13.6345 22.5031 11.6796 21.7672C10.9973 21.5106 10.3192 21.4708 9.6504 21.7663C8.58302 22.238 7.52915 22.7377 6.46515 23.2162C6.25404 23.311 6.18311 23.4364 6.1848 23.6727C6.19746 25.1648 6.19155 26.657 6.19155 28.1492C6.19071 28.4465 6.19071 28.7412 6.19071 29.0529ZM1.12404 26.5944C1.12404 27.747 1.1232 28.9004 1.12488 30.053C1.12573 30.512 1.30053 30.6916 1.74978 30.6924C2.6888 30.6949 3.62697 30.6949 4.566 30.6924C4.99751 30.6916 5.17738 30.5095 5.17738 30.0725C5.17906 27.7775 5.17822 25.4816 5.17653 23.1865C5.17653 22.747 4.99835 22.5641 4.56937 22.5624C3.63035 22.559 2.69217 22.5599 1.75315 22.5624C1.30053 22.5632 1.12573 22.7411 1.12488 23.1984C1.12235 24.3307 1.1232 25.4621 1.12404 26.5944Z"
                fill="white"
              />
              <path
                d="M21.9128 3.75831C25.82 3.76509 28.9934 6.96797 28.99 10.9017C28.9867 14.8287 25.798 18.0358 21.8967 18.0366C17.9844 18.0375 14.7949 14.8151 14.8042 10.8695C14.8135 6.94087 18.0013 3.75154 21.9128 3.75831ZM27.9767 10.8966C27.9784 7.51166 25.2627 4.77626 21.9001 4.77541C18.5367 4.77372 15.8192 7.50743 15.8192 10.8924C15.8192 14.2757 18.5409 17.0195 21.8959 17.0195C25.2525 17.0195 27.975 14.2782 27.9767 10.8966Z"
                fill="white"
              />
              <path
                d="M20.3977 21.4848C20.5716 21.7279 20.7202 21.9294 20.8621 22.1361C21.08 22.4536 21.0487 22.7212 20.7785 22.9093C20.5226 23.0871 20.2609 23.0312 20.0472 22.7365C19.6495 22.1903 19.2551 21.6415 18.8667 21.0876C18.6395 20.7633 18.6843 20.5134 19.0111 20.2746C19.5473 19.8817 20.0878 19.4947 20.6307 19.111C20.9423 18.8908 21.2218 18.9205 21.4059 19.1788C21.5917 19.4388 21.5275 19.7072 21.2185 19.9367C21.0006 20.0985 20.7777 20.2543 20.5657 20.488C20.9558 20.5151 21.346 20.5575 21.737 20.5668C26.4878 20.6777 30.7159 17.0921 31.405 12.3716C32.1726 7.11588 28.745 2.30309 23.5542 1.36729C23.0273 1.27244 22.4851 1.25804 21.9489 1.22163C21.5681 1.19622 21.3646 1.0277 21.3688 0.702496C21.373 0.37899 21.5799 0.205378 21.9641 0.202838C26.8273 0.171503 31.2952 3.8046 32.2866 8.59621C33.495 14.4354 30.0058 19.9452 24.2222 21.3188C22.9791 21.6144 21.7192 21.6584 20.3977 21.4848Z"
                fill="white"
              />
              <path
                d="M2.62991 28.6608C2.90858 28.654 3.13827 28.8683 3.15009 29.1469C3.16276 29.4416 2.93729 29.6771 2.64342 29.6762C2.36645 29.6754 2.14098 29.4526 2.13676 29.1749C2.13338 28.8971 2.35378 28.6676 2.62991 28.6608Z"
                fill="white"
              />
              <path
                d="M21.3671 7.33952C21.4499 6.46893 21.5462 6.28939 21.9127 6.30294C22.2758 6.31649 22.3611 6.48841 22.4185 7.35053C23.2055 7.56902 23.7358 8.08307 24.0204 8.85542C24.1606 9.23482 24.0719 9.50074 23.7687 9.62185C23.4673 9.7421 23.2173 9.61337 23.0788 9.22127C22.6895 8.11949 21.4896 8.1288 20.9964 8.68435C20.8622 8.83594 20.7499 9.03326 20.6983 9.22805C20.5624 9.7421 20.6941 9.95975 21.2185 10.0656C21.7134 10.1655 22.2209 10.2003 22.7166 10.2968C23.941 10.5348 24.4595 11.5053 23.9984 12.6731C23.7468 13.3117 23.2807 13.7283 22.6482 13.968C22.5705 13.9976 22.4903 14.0205 22.4016 14.0493C22.4016 14.1873 22.4092 14.3144 22.3999 14.4397C22.3788 14.7463 22.1778 14.9394 21.8924 14.936C21.6247 14.9334 21.3773 14.7395 21.4035 14.4626C21.4372 14.1018 21.2582 13.9858 20.9745 13.8672C20.3302 13.5971 19.9535 13.0729 19.7399 12.4233C19.636 12.1066 19.7543 11.8584 20.0355 11.7551C20.3192 11.651 20.5691 11.7602 20.6874 12.0795C20.8757 12.5884 21.1712 12.9628 21.7387 13.0585C22.4489 13.1779 23.1287 12.6198 23.1413 11.9016C23.1472 11.5756 23.0265 11.3994 22.6701 11.3308C22.2057 11.2411 21.7328 11.1886 21.2633 11.1276C20.1967 10.9879 19.5879 10.3586 19.647 9.41775C19.707 8.45993 20.1984 7.80106 21.0826 7.43775C21.1695 7.40218 21.2607 7.37593 21.3671 7.33952Z"
                fill="white"
              />
            </g>
            <defs>
              <clipPath id="clip0_1077_6259">
                <rect width="33" height="33" fill="white" />
              </clipPath>
            </defs>
          </svg>
        </v-list-item-icon>

        <v-list-item-content>
          <v-list-item-title>{{ $t("Refund Requests") }}</v-list-item-title>
        </v-list-item-content>
      </v-list-item>
      <!------------------------ Academic Setup -------------------------->

      <!-- ----------------end --------------------------->
    </v-list>
  </v-navigation-drawer>
</template>

<script>
import ACL from "../acl";

export default {
  name: "SideBar",
  props: {},
  data() {
    return {
      currentAppLocale: localStorage.locale,
      /* ===========sidebar data =================== */
      isWarehouseStaff: ACL.Role("Warehouse Staff"),
      isCanteenStaff: ACL.Role("Canteen Staff"),
      isSuperAdmin: ACL.Role("Super-Admin"),
      isParent: ACL.Role("Parent"),
      isStudent: ACL.Role("Student"),
      isAccountant: ACL.Role("Accountant"),

      schoolSetup: [
        {
          title: this.$i18n.t("School"),
          to: "/school",
          enabled: true,
        },
        {
          title: this.$i18n.t("Canteens"),
          to: "/canteens",
          enabled: true,
        },
      ],
      canteenStaff: [
        {
          title: this.$i18n.t("Staff Members"),
          to: "/Staff-Members",
          enabled: true,
        },
      ],
      productsItems: [
        {
          title: this.$i18n.t("Product Data"),
          to: "/productData",
          enabled: true,
        },
        {
          title: this.$i18n.t("Quantities"),
          to: "/quantities",
          enabled: true,
        },
      ],
      ordersItems: [
        {
          title: this.$i18n.t("Orders"),
          to: "/orders",
          enabled: true,
        },
      ],
      auth_id: localStorage.getItem("auth_id"),

      miniVariant: false,
      expandOnHover: false,
      background: false,
      mini: true,
      localimage:
        localStorage["school_logo"] != undefined &&
        localStorage["school_logo"] != "null"
          ? localStorage["school_logo"]
          : require("../assets/logo.png"),

      masterDataMenu: {
        offsetX: true,
        offsetY: true,
        value: false,
        closeOnClick: true,
        closeOnContentClick: true,
      },

      //   offsetX: true,
      //   offsetY: true,
      //   value: false,
      //   closeOnClick: true,
      //   closeOnContentClick: true,
      // },
      logo: "",
      school_name: "",
    };
  },

  computed: {
    getSideBarMin() {
      // console.log("Islam");

      // console.log(
      //   "this.$store.state.sidebarMin = ",
      //   this.$store.state.sidebarMin
      // );
      // console.log("this.$store = ", this.$store);
      return this.$store.state.sidebarMin;
    },
    drawer: {
      // getter
      get: function () {
        return this.$vuetify.breakpoint.name == "xs" ||
          this.$vuetify.breakpoint.name == "sm"
          ? this.$store.getters.getSidebarDisplay
          : true;
      },
      set: function () {},
    },
    bg() {
      return this.background
        ? "https://cdn.vuetifyjs.com/images/backgrounds/bg-2.jpg"
        : undefined;
    },
    largeScreen() {
      return this.$vuetify.breakpoint.name == "xs" ||
        this.$vuetify.breakpoint.name == "sm"
        ? false
        : true;
    },
  },
  methods: {
    masterDatashowMenu() {
      if (this.miniVariant == true) {
        this.masterDataMenu.value = true;
      }
    },

    getForm() {
      this.$router.push("/MasterData");
    },
    setSideBarMin() {
      this.miniVariant = !this.miniVariant;
      this.$store.commit("setSideBarMin");
    },
    closeSidebar() {
      console.log("ACL.Role('Super-Admin')", ACL.Role("Super-Admin"));
      this.$store.commit("setSidebarDisplay");
      // this.drawer = false;
    },
    canSee() {
      return true;
      // return (
      //   arr.find((element) => {
      //     return element.enabled == true;
      //   }) != undefined
      // );
    },
    // menuHasActive() {
    //   let path = window.location.pathname;
    //   let arraySchoolSetup = [
    //     "/MasterData",
    //     "/academics",
    //     "/subject_type",
    //     "/subjects",
    //     "/grades",
    //     "/workingdays",
    //     "/gradingsystem",
    //   ];
    //   let arrayAcademicSetup = [
    //     "/curriculum_setup/active",
    //     "/qualifier",
    //     "/classmanagement/all",
    //   ];
    //   let arrayStudents = ["/applicants", "/admissionExam", "/students"];

    //   let arrayTeachers = ["/teachers"];

    //   let arrayFianacial = [
    //     "/financialstatus",
    //     "/feeplans",
    //     "/taxes",
    //     "/cashpoints",
    //     "/partners",
    //     "/invoices",
    //     "/payments",
    //     "/bankReceipts",
    //     "/allAccounts/types",
    //     "/accounts",
    //     "/discount_packages",
    //   ];

    //   let arrayClassRoom = [
    //     "/attendance/students",
    //     "/discussionrooms",
    //     "/homework",
    //     "/digital_library",
    //     "/studentAttendance",
    //     "/attendanceChild",
    //   ];

    //   let arrayItemsSetup = ["/itemsCategories", "/items"];

    //   let arrayWarehouses = [
    //     "/WarehouseTransaction",
    //     "/BooksList",
    //     "/WarehouseItems",
    //   ];

    //   let arrayNotifications = ["/notificationsLogs", "/notificationTemplates"];

    //   let arrayHrmodule = [
    //     "/hrConfigrations",
    //     "/employees",
    //     "/allEmployees/salaries",
    //     "/MasterAttendance",
    //     "/VacationRequests",
    //   ];

    //   let arrayUsers = ["/user_management", "/all_users"];

    //   if (arraySchoolSetup.includes(path)) {
    //     this.$refs.schoolSetup.click();
    //   } else if (arrayAcademicSetup.includes(path)) {
    //     this.$refs.academicSetup.click();
    //   } else if (arrayStudents.includes(path)) {
    //     this.$refs.students.click();
    //   } else if (arrayTeachers.includes(path)) {
    //     this.$refs.teachers.click();
    //   } else if (arrayFianacial.includes(path)) {
    //     this.$refs.fianacial.click();
    //   } else if (arrayClassRoom.includes(path)) {
    //     this.$refs.classRoom.click();
    //   } else if (arrayItemsSetup.includes(path)) {
    //     this.$refs.itemsSetup.click();
    //   } else if (arrayWarehouses.includes(path)) {
    //     this.$refs.Warehouses.click();
    //   } else if (arrayNotifications.includes(path)) {
    //     this.$refs.Notifications.click();
    //   } else if (arrayHrmodule.includes(path)) {
    //     this.$refs.hrmodule.click();
    //   } else if (arrayUsers.includes(path)) {
    //     this.$refs.Users.click();
    //   }
    // },
  },
  mounted() {
    this.school_name =
      localStorage.school_name && localStorage.school_name != "null"
        ? localStorage.school_name
        : "SMS";
    // this.logo = localStorage.logo ? localStorage.logo : "null";
    // this.menuHasActive();
  },
};
</script>

<style scoped lang="scss">
.main-sidebar {
  background-color: #7297ff !important;
  z-index: 11;
}
.not-printable {
  // display: none !important;
}

.v-list-item {
  min-height: 35px;
}

.single {
  padding-left: 16px !important;
}
</style>
